import { postRequest } from '@/core';
import { packageTypes } from '@/requests';

export default async function getPackageTypesRequest() {
	let url = packageTypes.getSyncPath();
	let response = await postRequest(url);
	return response;
}